import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import { Button } from "../Button/index.js";
import { Icon } from "../Icon/index.js";
import { useStyles } from "./DropdownButton.styles.js";
const iconColors = {
    primary: 'bg.light.primary',
    secondary: 'original.brand.primary',
    tertiaryLight: 'text.light.primary',
    quaternary: 'original.brand.primary'
};
const DropdownButton = (t0)=>{
    const $ = c(51);
    const { variant, menuItems, verticalPosition, horizontalPosition, onOpen, onClose, disabled: t1, button, testId, size: t2, horizonIcon, container } = t0;
    const disabled = void 0 === t1 ? false : t1;
    const size = void 0 === t2 ? "small" : t2;
    const [anchorEl, setAnchorEl] = useState(null);
    const { classes } = useStyles();
    let t3;
    if ($[0] !== onOpen) {
        t3 = (event)=>{
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
            null == onOpen || onOpen();
        };
        $[0] = onOpen;
        $[1] = t3;
    } else t3 = $[1];
    const handleOpen = t3;
    let t4;
    if ($[2] !== onClose) {
        t4 = (event_0)=>{
            event_0.stopPropagation();
            setAnchorEl(null);
            null == onClose || onClose();
        };
        $[2] = onClose;
        $[3] = t4;
    } else t4 = $[3];
    const handleClose = t4;
    const t5 = horizonIcon ? "more_horizontal" : "more_vertical";
    const t6 = "small" === size || "extraSmall" === size ? "16" : "24";
    const t7 = iconColors[variant];
    let t8;
    if ($[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
        t8 = /*#__PURE__*/ jsx(Icon, {
            name: t5,
            size: t6,
            color: t7,
            "data-testid": "dropdown-button-more-vert-icon"
        });
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    const icon = t8;
    if (disabled) {
        let t9;
        if ($[8] !== anchorEl || $[9] !== button || $[10] !== disabled || $[11] !== handleOpen || $[12] !== icon || $[13] !== size || $[14] !== variant) {
            t9 = button ? /*#__PURE__*/ jsx(Fragment, {
                children: button({
                    onClick: handleOpen,
                    isOpened: !!anchorEl,
                    isDisabled: disabled
                })
            }) : /*#__PURE__*/ jsx(Button, {
                variant: variant,
                size: size,
                icon: icon,
                disabled: disabled,
                onClick: handleOpen,
                disableRipple: true
            });
            $[8] = anchorEl;
            $[9] = button;
            $[10] = disabled;
            $[11] = handleOpen;
            $[12] = icon;
            $[13] = size;
            $[14] = variant;
            $[15] = t9;
        } else t9 = $[15];
        return t9;
    }
    let t9;
    if ($[16] !== anchorEl || $[17] !== button || $[18] !== disabled || $[19] !== handleOpen || $[20] !== icon || $[21] !== size || $[22] !== testId || $[23] !== variant) {
        t9 = button ? /*#__PURE__*/ jsx(Fragment, {
            children: button({
                onClick: handleOpen,
                isOpened: !!anchorEl,
                isDisabled: disabled
            })
        }) : /*#__PURE__*/ jsx(Button, {
            variant: variant,
            size: size,
            testId: testId,
            icon: icon,
            onClick: handleOpen,
            disableRipple: true
        });
        $[16] = anchorEl;
        $[17] = button;
        $[18] = disabled;
        $[19] = handleOpen;
        $[20] = icon;
        $[21] = size;
        $[22] = testId;
        $[23] = variant;
        $[24] = t9;
    } else t9 = $[24];
    const t10 = `${"bottom" === verticalPosition ? classes.paper : ""}`;
    let t11;
    if ($[25] !== classes.menuList || $[26] !== classes.rootPaper || $[27] !== t10) {
        t11 = {
            list: classes.menuList,
            root: classes.rootPaper,
            paper: t10
        };
        $[25] = classes.menuList;
        $[26] = classes.rootPaper;
        $[27] = t10;
        $[28] = t11;
    } else t11 = $[28];
    const t12 = Boolean(anchorEl);
    let t13;
    if ($[29] !== horizontalPosition || $[30] !== verticalPosition) {
        t13 = {
            vertical: verticalPosition,
            horizontal: horizontalPosition
        };
        $[29] = horizontalPosition;
        $[30] = verticalPosition;
        $[31] = t13;
    } else t13 = $[31];
    const t14 = "top" === verticalPosition ? "bottom" : "top";
    let t15;
    if ($[32] !== horizontalPosition || $[33] !== t14) {
        t15 = {
            vertical: t14,
            horizontal: horizontalPosition
        };
        $[32] = horizontalPosition;
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = {
            appear: 200,
            enter: 200,
            exit: 0
        };
        $[35] = t16;
    } else t16 = $[35];
    let t17;
    if ($[36] !== handleClose || $[37] !== menuItems) {
        t17 = /*#__PURE__*/ jsx("div", {
            onClick: handleClose,
            children: menuItems
        });
        $[36] = handleClose;
        $[37] = menuItems;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== anchorEl || $[40] !== container || $[41] !== handleClose || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t15 || $[46] !== t17) {
        t18 = /*#__PURE__*/ jsx(Menu, {
            container: container,
            classes: t11,
            open: t12,
            onClose: handleClose,
            anchorEl: anchorEl,
            anchorOrigin: t13,
            transformOrigin: t15,
            transitionDuration: t16,
            "data-testid": "dropdownButton",
            children: t17
        });
        $[39] = anchorEl;
        $[40] = container;
        $[41] = handleClose;
        $[42] = t11;
        $[43] = t12;
        $[44] = t13;
        $[45] = t15;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    let t19;
    if ($[48] !== t18 || $[49] !== t9) {
        t19 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t9,
                t18
            ]
        });
        $[48] = t18;
        $[49] = t9;
        $[50] = t19;
    } else t19 = $[50];
    return t19;
};
export { DropdownButton };
